import {
  useGetShopItemsQuery,
  useDeleteShopItemMutation,
  useGetSubscriptionPurchasesByShopQuery,
  useGetBusinessTypeRulesQuery,
} from "../features/shop/shopApiSlice";
import { useGetMarketerByUserIdQuery } from "../features/marketing/marketingApiSlice";

/**
 * @param {string} shopid
 * @param {string} [userid]
 * @param {{ skip?: boolean, skipItems?: boolean }} [options]
 *   skipItems: when parent already loaded items (isDynamic), avoid a second
 *   getShopItems subscription that refetches on mount and fights the parent UI.
 */
export const useShopItemsData = (shopid, userid, options = {}) => {
  const { skip = false, skipItems = false } = options;
  const skipQuery = skip || !shopid || skipItems;

  const {
    data: shopItemsRes,
    isFetching: itemsFetching,
    isLoading: itemsLoading,
    refetch: refetchItems,
  } = useGetShopItemsQuery(
    { shopid },
    {
      skip: skipQuery,
      // Only force remount refetch when this hook is the primary data source
      refetchOnMountOrArgChange: !skipItems,
      refetchOnFocus: false,
    }
  );

  const {
    data: purchaseRes,
    isLoading: isLoadingPurchase,
  } = useGetSubscriptionPurchasesByShopQuery(shopid, {
    skip: !shopid || skip,
  });

  const { data: marketerRes } = useGetMarketerByUserIdQuery(userid, {
    skip: !userid,
  });

  const { data: businessTypeRules } = useGetBusinessTypeRulesQuery(undefined, {
    skip: skipItems,
  });

  const [deleteShopItem] = useDeleteShopItemMutation();

  const regular = shopItemsRes?.regular || [];
  const specialoffer = shopItemsRes?.specialoffer || [];
  const salespromotion = shopItemsRes?.salespromotion || [];
  const allItems =
    shopItemsRes?.data?.ShopItems ||
    shopItemsRes?.ShopItems ||
    [...regular, ...specialoffer, ...salespromotion];

  return {
    itemsData: shopItemsRes,
    itemsFetching,
    itemsLoading,
    refetchItems,
    purchaseData: purchaseRes,
    isLoadingPurchase,
    marketerData: marketerRes,
    businessTypeRules,
    deleteShopItem,
    // Aliases expected by UserItemShop
    data: allItems,
    filterregular: regular,
    filterspecial: specialoffer,
    filtersales: salespromotion,
    newsearchdata: [],
    vehiclesearchdata: [],
    filterData: null,
    filterDatavehicle: null,
    isLoading: !skipItems && itemsLoading,
  };
};
